/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';

/**
 *
 * @export
 * @interface SingleTurnChatDataset
 */
export interface SingleTurnChatDataset {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof SingleTurnChatDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatDataset
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {boolean}
   * @memberof SingleTurnChatDataset
   */
  groundTruthIsExhaustive?: boolean;
}

/**
 * Check if a given object implements the SingleTurnChatDataset interface.
 */
export function instanceOfSingleTurnChatDataset(value: object): value is SingleTurnChatDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function SingleTurnChatDatasetFromJSON(json: any): SingleTurnChatDataset {
  return SingleTurnChatDatasetFromJSONTyped(json, false);
}

export function SingleTurnChatDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleTurnChatDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    groundTruthIsExhaustive:
      json['ground_truth_is_exhaustive'] == null ? undefined : json['ground_truth_is_exhaustive'],
  };
}

export function SingleTurnChatDatasetToJSON(value?: Omit<SingleTurnChatDataset, 'id' | 'hasPredictions'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    ground_truth_is_exhaustive: value['groundTruthIsExhaustive'],
  };
}
